export enum ActiveLinkType {
  SequenceEntry = 'sequenceEntry',
  ConfirmOrder = 'confirmOrder',
  Specifications = 'specifications',
  ReviewPage = 'reviewPage',
  MultipleEntry = 'multipleEntry',
}
export enum GenomicProduct {
  CustomCrispr = 'customcrispr',
  FastDuplex = 'fastduplex',
  LightCycler = 'lightcycle',
  BiTube = 'bitube',
}

export enum ProductHeader {
  CustomCrispr = 'Custom siRNA in Tubes',
}

export enum GenomicsProperties {
  LoggedInUser = 'LoggedInUser',
  NameMaxLength = 16,
  GeneLength = 30,
  Name = 'name',
  GeneId = 'geneId',
  GeneSymbol = 'geneSymbol',
  SEQUENCE_API_TIME = 1000,
  SequenceKey = 'sequence',
  Quote = 'QUOTE',
  QuoteItem = 'Quote Item',
  Success = 'success',
  sequencePreview = 'Start typing sequence above to see the preview.',
  ModifiedFNCAS9TRACR = 'ModifiedFNCAS9TRACR',
}

export enum Buttons {
  AddToList = 'Add to List',
}

export enum ReducerTypes {
  INIT = 'INIT',
}

export enum SpecificationMessages {
  RNA = 'RNA',
  DNA = 'DNA',
  VIRUS = 'VIRUS',
  INVITRO = 'INVITRO',
  SPCAS9 = 'SPCAS9',
  FNCAS9 = 'FNCAS9',
  CRISPRSpecies = 'CRISPR Species',
  species = 'species',
  Two = '2',
  Five = '5',
  Three = '3',
  ScaleofSynthesis = 'Scale of Synthesis',
  Yes = 'Y',
  No = 'N',
  Modified = 'Modified',
  modification = 'modification',
  DESALT = 'DESALT',
  HPLC = 'HPLC',
  Purification = 'purification',
  CRRNA = 'CRRNA',
  SYGRNA = 'SYGRNA',
  powerof6 = 'powerof6',
  powerof7 = 'powerof7',
  powerof8 = 'powerof8',
  powerof9 = 'powerof9',
  TenPSix = '10^6',
  TenPSeven = '10^7',
  TenPEight = '10^8',
  TenPNine = '10^9',
  pointTwo = 'pointTwo',
  pointOne = 'pointOne',
  volOne = 'volOne',
  volTwo = 'volTwo',
  volFive = 'volFive',
  dotTwo = '0.2',
  dotOne = '0.1',
  one = '1',
  twoVol = '2',
  fiveVol = '5',
  ten = '10',
  TwentyFive = '25',
  hundred = '100',
  oneRom = 'one',
  tenRom = 'ten',
  twentyFiveRom = 'twentyFive',
  hundredRom = 'hundred',
  dry = 'DRY',
  lv01 = 'LV01',
  LV02 = 'LV02',
  LV03 = 'LV03',
  LV04 = 'LV04',
  LV05 = 'LV05',
  p01 = 'p01',
  p02 = 'p02',
  p03 = 'p03',
  p04 = 'p04',
  p05 = 'p05',
  Mul1X200 = 'Mul1X200',
  Mul2X100 = 'Mul2X100',
  Mul4X50 = 'Mul4X50',
  Mul8X25 = 'Mul8X25',
  Mul5X20 = 'Mul5X20',
  Mul2X50 = 'Mul2X50',
  Mul4X25 = 'Mul4X25',
  Mul5X200 = 'Mul5X200',
  Mul10X100 = 'Mul10X100',
  Mul20X50 = 'Mul20X50',
  Mul40X25 = 'Mul40X25',
  Mul25X200 = 'Mul25X200',
  Mul50X100 = 'Mul50X100',
  Mul100X50 = 'Mul100X50',
  Mul200X25 = 'Mul200X25',
  Mul10X200 = 'Mul10X200',
  Mul20X100 = 'Mul20X100',
  Mul40X50 = 'Mul40X50',
  Mul80X25 = 'Mul80X25',
  Mul50X20 = 'Mul50X20',
  Mul100X20 = 'Mul100X20',
  Mul10X20 = 'Mul10X20',
  mul1x200 = '1 x 200',
  mul2X100 = '2 x 100',
  mul4X50 = '4 x 50',
  mul8X25 = '8 x 25',
  mul5X20 = '5 x 20',
  mul2X50 = '2 x 50',
  mul4X25 = '4 x 25',
  mul5X200 = '5 x 200',
  mul10X100 = '10 x 100',
  mul20X50 = '20 x 50',
  mul40X25 = '40 x 25',
  mul25X200 = '25 x 200',
  mul50X100 = '50 x 100',
  mul100X50 = '100 x 50',
  mul200X25 = '200 x 25',
  mul10X200 = '10 x 200',
  mul20X100 = '20 x 100',
  mul40X50 = '40 x 50',
  mul80X25 = '80 x 25',
  mul50X20 = '50 x 20',
  mul100X20 = '100 x 20',
  mul10X20 = '10 x 20',
  LV01Val = '(LV01) U6-gRNA:ef1a-puro-2A-Cas9-2A-tGFP (Sigma all-in-one lentivirus)',
  LV02Val = '(LV02) U6-gRNA:ef1a-puro (GeCKOv2:puro lentivirus)',
  LV03Val = '(LV03) U6-gRNA:ef1a-tGFP (GeCKOv2:tGFP lentivirus)',
  LV04Val = '(LV04) U6-gRNA:hPGK-puro-2A-tBFP (Sanger lentivirus)',
  LV05Val = '(LV05) U6-gRNA:EF1a-Cas9+FLAG-2A-puro (GeCKOv2 all-in-one lentivirus)',
  TenPSixVal = '10^6 particles/ml',
  TenPSevenVal = '10^7 particles/ml',
  TenPEightVal = '10^8 particles/ml',
  TenPNineVal = '10^9 particles/ml',
  mul1x200Val = '1 x 200 μl',
  mul2X100Val = '2 x 100 μl',
  mul4X50Val = '4 x 50 μl',
  mul8X25Val = '8 x 25 μl',
  mul5X20Val = '5 x 20 μl',
  mul2X50Val = '2 x 50 μl',
  mul4X25Val = '4 x 25 μl',
  mul5X200Val = '5 x 200 μl',
  mul10X100Val = '10 x 100 μl',
  mul20X50Val = '20 x 50 μl',
  mul40X25Val = '40 x 25 μl',
  mul25X200Val = '25 x 200 μl',
  mul50X100Val = '50 x 100 μl',
  mul100X50Val = '100 x 50 μl',
  mul200X25Val = '200 x 25 μl',
  mul10X200Val = '10 x 200 μl',
  mul20X100Val = '20 x 100 μl',
  mul40X50Val = '40 x 50 μl',
  mul80X25Val = '80 x 25 μl',
  mul50X20Val = '50 x 20 μl',
  mul100X20Val = '100 x 20 μl',
  mul10X20Val = '10 x 20 μl',
  dotTwoVal = '200 μl',
  dotOneVal = '100 μl',
  oneVolVal = '1 ml',
  twoVolVal = '2 ml',
  fiveVolVal = '5 ml',
  RNAVal = 'Synthetic RNA',
  VIRUSVal = 'Lentivirus',
  DNAVal = 'Plasmid DNA',
  LV01Vec = '(LV01) U6-gRNA:ef1a-puro-2A-Cas9-2A-tGFP (Sigma all-in-one lentiviral plasmid)',
  LV02Vec = '(LV02) U6-gRNA:ef1a-puro (GeCKOv2:puro lentiviral plasmid)',
  LV03Vec = '(LV03) U6-gRNA:ef1a-tGFP (GeCKOv2:tGFP lentiviral plasmid)',
  LV04Vec = '(LV04) U6-gRNA:hPGK-puro-2A-tBFP (Sanger lentiviral plasmid)',
  LV05Vec = '(LV05) U6-gRNA:EF1a-Cas9+FLAG-2A-puro (GeCKOv2 all-in-one lentiviral plasmid)',
  p01Vec = '(p01) U6-gRNA:CMV-Cas9-2a-tGFP (transfection plasmid)',
  p02Vec = '(p02) U6-gRNA:CMV-Cas9-2A-tRFP (transfection plasmid)',
  p03Vec = '(p03) U6-gRNA (transfection plasmid)',
  p04Vec = '(p04) U6-gRNA:CMV-eCas9-2a-tGFP (transfection plasmid)',
  p05Vec = '(p05) U6-gRNA:CMV-eCas9-2a-tRFP (transfection plasmid)',
  oneVal = '1 μg',
  tenVal = '10 μg',
  TwentyFiveVal = '25 μg',
  hundredVal = '100 μg',
  YesVal = 'Yes',
  NoVal = 'No',
  DESALTVal = 'Desalt',
  ThreeVal = '3 nmol',
  TwoVal = '2 nmol',
  FiveVal = '5 nmol',
  SPCAS9Val = 'SpCas9',
  FNCAS9Val = 'FnCas9 (For noncellular, synthetic applications)',
  CRRNAVal = 'crRNA (tracrRNA sold separately)',
  SYGRNAVal = 'sgRNA (crRNA +tracrRNA as one)',
  quote = 'QUOTE',
  All = 'All',
  Selected = 'Selected',
  Control = 'Control',
  Recommended = 'Recommended',
  microLtr = ' μl',
  noSelection = 'noSelection',
  Select = 'Select',
  SRNA = 'SRNA',
  VITRO = 'VITRO',
  Structure = 'structure',
  scale = 'scale',
  aliquoting = 'aliquoting',
  volume = 'volume',
  sequencePreview = 'Start typing sequence above to see the preview.',
}

export enum ErrorMessage {
  SessionDataEmpty = 'ERROR_SESSION_DATA_EMPTY',
  AccessTokenExpire = 'ERROR_USER_INVALID_OR_EXPIRED_ACCESS_TOKEN',
}

export enum FileFormat {
  InvalidTemplate = 'INVALID_TEMPLATE',
  MultipleLineError = 'MULTIPLE_LINE_ERROR',
  AcceptFormat = '.csv,.xls,.xlsx, text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
}

export enum UploadGenomicsType {
  fileUpload = 'fileUpload',
  prodType = 'Genomics',
}
